/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Table: Master inventory records
************************************************************************/
import React from 'react';
import moment from 'moment';
import CultivationModal from '../cult_modal';
import TreeInventoryMasterDisplay from './tree_inventory_master_display';
import { sumProp } from '../../cult_utils';

const TreeInventoryTable = ({ inventory, inventoryTransactions, employees, onClick }) => {
  if (inventory.length === 0) return <div></div>;
  return (
    <table className="highlight bordered centered responsive-table">
      <thead>
        <tr>
          <th>Nursery Field</th>
          <th>Location</th>
          <th>Tree Total</th>
          <th>Tree Received</th>
          <th>Tree Issued</th>
          <th>Date Issued</th>
          <th>Date Received</th>
          <th>Last Issue</th>
          <th>Last Received</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {
          inventory.map((i) => {
            let empIssued = 'N/A';
            let empReceived = 'N/A';
            if (i.lastEIDIssued) {
              empIssued = i.lastEIDIssued;
            }
            if (i.lastEIDReceived !== null) {
              empReceived = i.lastEIDReceived;
            }
            return (
              <tr key={i.id}>
                <td>{ i.physicalLocation }</td>
                <td>{ i.location === '71' ? "71 - Ka'u" : "72 - Kea'au" }</td>
                <td>{ i.inventoryTotal }</td>
                <td>{ i.inventoryReceived }</td>
                <td>{ i.inventoryIssued }</td>
                <td>{ i.lastDateIssued ? <span className="blue-text">{moment(i.lastDateIssued).format('MM/DD/YYYY')}</span> : '' }</td>
                <td>{ i.lastDateReceived ? <span className="green-text">{moment(i.lastDateReceived).format('MM/DD/YYYY')}</span> : '' }</td>
                <td>{ empIssued }</td>
                <td>{ empReceived }</td>
                <td>
                  <ul className="btn-actions">
                    <li className="action-btn-li">
                      <a className="btn-floating green pointer modal-trigger tooltipped btn-squared" href={`#${i.physicalLocation}-view`}
                        data-position="left" data-tooltip="View">
                        <i className="material-icons">info</i>
                      </a>
                    </li>
                    <li className="action-btn-li">
                      <a className={`btn-floating grey pointer tooltipped btn-squared`} href={`#${i.physicalLocation}-download`}
                        onClick={() => onClick(i)} data-position="top" data-tooltip="Download">
                        <i className="material-icons">cloud_download</i>
                      </a>
                    </li>
                  </ul>
                  <div>
                  {
                    CultivationModal(TreeInventoryMasterDisplay)
                    // eslint-disable-next-line
                    ({
                      id: `${i.physicalLocation}-view`,
                      inventory: i,
                      inventoryTransactions: inventoryTransactions.filter((item) => item.inventoryId === i.inventoryId),
                      footer: true,
                      createOrEdit: false,
                      view: true
                    })
                  }
                  </div>
                </td>
              </tr>
          )
        })
        }
      </tbody>
      <tfoot>
        <tr>
          <td><center>Totals</center></td>
          <td></td>
          <td><center><b>{ sumProp('inventoryTotal', inventory) }</b></center></td>
          <td><center><b>{ sumProp('inventoryReceived', inventory) }</b></center></td>
          <td><center><b>{ sumProp('inventoryIssued', inventory) }</b></center></td>
        </tr>
      </tfoot>
    </table>
  )
}

export default TreeInventoryTable;





























/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory_table.js